import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import moment from "moment";
const SecurityCenter = () => {
  const navigate = useNavigate();
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const logoutUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.logoutUser;
  });
  const [lastLogin, setLastLogin] = useState({});
  const getData = async (body) => {
    const { status, data } = await apiGet(apiPath.activityLogs);
    if (status == 200) {
      if (data?.success) {
        setLastLogin(data?.results?.data[0]);
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div className="security-center">
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-securityCenter mc-default-header am-navbar am-navbar-light"
          >
            <div
              onClick={() => navigate(-1)}
              className="am-navbar-left"
              role="button"
            >
              <span className="am-navbar-left-content">
                <span style={{paddingLeft:"0"}} className="return_icon">
                  <svg
                    style={{ color: "black" }}
                    className="am-icon am-icon-left am-icon-lg"
                  >
                    <use xlinkHref="#left" />
                  </svg>
                </span>
              </span>
            </div>
            <div className="am-navbar-title">Security Center</div>
            <div className="am-navbar-right" />
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>
        <div className="card-list-item">
          {/* <div className="security-circle">
            <div className="origin">
              <div className="circle-root">
                <canvas id="canvas_1" width={160} height={160} />
                <canvas id="canvas_2" width={160} height={160} />
              </div>
            </div>
          </div> */}
          <div className="flex-center">
            <div className="circleR">
              <div className="center-header">
                {/* react-text: 7491 */}Safety percentage{/* /react-text */}
                {/* react-text: 7492 */}:&nbsp;{/* /react-text */}
                {/* react-text: 7493 */}Low{/* /react-text */}
              </div>
              <div className="center-svgBox">
                <div>
                  <svg className="am-icon am-icon-lightning_cdf0a8f8 am-icon-xs center-svgL need-fill">
                    <use xlinkHref="#lightning_cdf0a8f8" />
                  </svg>
                  <svg
                    className="am-icon am-icon-lightning_cdf0a8f8 am-icon-xs center-svgL"
                    color="#cdcdcd"
                  >
                    <use xlinkHref="#lightning_cdf0a8f8" />
                  </svg>
                  <svg
                    className="am-icon am-icon-lightning_cdf0a8f8 am-icon-xs center-svgL"
                    color="#cdcdcd"
                  >
                    <use xlinkHref="#lightning_cdf0a8f8" />
                  </svg>
                  <svg
                    className="am-icon am-icon-lightning_cdf0a8f8 am-icon-xs center-svgL"
                    color="#cdcdcd"
                  >
                    <use xlinkHref="#lightning_cdf0a8f8" />
                  </svg>
                  <svg
                    className="am-icon am-icon-lightning_cdf0a8f8 am-icon-xs center-svgL"
                    color="#cdcdcd"
                  >
                    <use xlinkHref="#lightning_cdf0a8f8" />
                  </svg>
                </div>
              </div>
            </div>
            <div>
              <div className="flex-tips">
                {/* react-text: 7508 */}Last login ip{/* /react-text */}
                {/* react-text: 7509 */}:&nbsp;&nbsp;&nbsp;{/* /react-text */}
                {/* react-text: 7510 */}
                {lastLogin?.ip || "-"}
                {/* /react-text */}
              </div>
              <div className="flex-tips">
                {/* react-text: 7512 */}Last login time{/* /react-text */}
                {/* react-text: 7513 */}:&nbsp;&nbsp;&nbsp;{/* /react-text */}
                {/* react-text: 7514 */}
                {moment(lastLogin?.createdAt).format("YYYY-DD-MM hh:mm:ss")}
                {/* /react-text */}
              </div>
            </div>
          </div>
        </div>
        <div className="am-flexbox am-flexbox-align-middle">
          <div className="flex-text-tips">
            {/* react-text: 7517 */}Your account security level is Low
            {/* /react-text */}
            {/* react-text: 7518 */}，{/* /react-text */}
            {/* react-text: 7519 */}Please improve your safety information
            {/* /react-text */}
          </div>
        </div>
        <div className="am-flexbox am-flexbox-align-middle">
          <div className="card-btm  security-list">
            <div className="am-list">
              <div className="am-list-body">
                <div
                  onClick={() => navigate("/member/profile")}
                  className="flex-list-item am-list-item am-list-item-middle"
                >
                  <div className="am-list-line">
                    <div className="am-list-content">
                      <div className="flex-grad-one">
                        <svg
                          className="am-icon am-icon-profile_91540dcb am-icon-lg flex-list-icon1 security-icon"
                          color="#cccccc"
                        >
                          <use xlinkHref="#profile_91540dcb" />
                        </svg>
                      </div>
                      <div className="flex-list-con">
                        <p className="flex-list-header">
                          <span className="flex-list-text">
                            Personal information
                          </span>
                          <span className="flex-list-icon">
                            <svg className="am-icon am-icon-unsett_c1731e83 am-icon-xs flex-list-icon1 icon-complete flex-list-icon-unsett">
                              <use xlinkHref="#unsett_c1731e83" />
                            </svg>
                            <svg className="am-icon am-icon-edit_0f6eb9f1 am-icon-md edit-icon">
                              <use xlinkHref="#edit_0f6eb9f1" />
                            </svg>
                          </span>
                        </p>
                        <p className="flex-list-title flex-list-desc">
                          Complete personal information.
                        </p>
                      </div>
                      <div className="flex-grad-arrows">
                        <svg
                          className="am-icon am-icon-rightarrows_e029c01f am-icon-md"
                          color="#A6A6A6"
                        >
                          <use xlinkHref="#rightarrows_e029c01f" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="flex-list-item am-list-item am-list-item-middle">
                  <div className="am-list-line">
                    <div className="am-list-content">
                      <div className="flex-grad-one">
                        <svg
                          className="am-icon am-icon-bindEwallet_ee5bf137 am-icon-lg flex-list-icon1 security-icon"
                          color="#cccccc"
                        >
                          <use xlinkHref="#bindEwallet_ee5bf137" />
                        </svg>
                      </div>
                      <div className="flex-list-con">
                        <p className="flex-list-header">
                          <span className="flex-list-text">Bind E-wallet</span>
                          <span className="flex-list-icon">
                            <svg className="am-icon am-icon-unsett_c1731e83 am-icon-xs flex-list-icon1 icon-complete flex-list-icon-unsett">
                              <use xlinkHref="#unsett_c1731e83" />
                            </svg>
                            <svg className="am-icon am-icon-edit_0f6eb9f1 am-icon-md edit-icon">
                              <use xlinkHref="#edit_0f6eb9f1" />
                            </svg>
                          </span>
                        </p>
                        <p className="flex-list-title flex-list-desc">
                          Bind E-wallet for withdrawal.
                        </p>
                      </div>
                      <div className="flex-grad-arrows">
                        <svg
                          className="am-icon am-icon-rightarrows_e029c01f am-icon-md"
                          color="#A6A6A6"
                        >
                          <use xlinkHref="#rightarrows_e029c01f" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div
                  onClick={() => navigate("/member/change-password")}
                  className="flex-list-item am-list-item am-list-item-middle"
                >
                  <div className="am-list-line">
                    <div className="am-list-content">
                      <div className="flex-grad-one">
                        <svg
                          className="am-icon am-icon-otherLock_79d1fd21 am-icon-lg flex-list-icon1 security-icon"
                          color="#cccccc"
                        >
                          <use xlinkHref="#otherLock_79d1fd21" />
                        </svg>
                      </div>
                      <div className="flex-list-con">
                        <p className="flex-list-header">
                          <span className="flex-list-text">
                            Change login password
                          </span>
                          <span className="flex-list-icon">
                            <svg className="am-icon am-icon-cancal_462cf10f am-icon-xs flex-list-icon1 icon-complete">
                              <use xlinkHref="#cancal_462cf10f" />
                            </svg>
                            <svg className="am-icon am-icon-edit_0f6eb9f1 am-icon-md edit-icon">
                              <use xlinkHref="#edit_0f6eb9f1" />
                            </svg>
                          </span>
                        </p>
                        <p className="flex-list-title flex-list-desc">
                          Recommended letter and number combination
                        </p>
                      </div>
                      <div className="flex-grad-arrows">
                        <svg
                          className="am-icon am-icon-rightarrows_e029c01f am-icon-md"
                          color="#A6A6A6"
                        >
                          <use xlinkHref="#rightarrows_e029c01f" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="am-list-ripple" style={{ display: "none" }} />
                </div>
                {/* <div className="flex-list-item am-list-item am-list-item-middle">
                  <div className="am-list-line">
                    <div className="am-list-content">
                      <div className="flex-grad-one">
                        <svg
                          className="am-icon am-icon-otherMoneyPassword_c96dfc31 am-icon-lg flex-list-icon1 security-icon"
                          color="#cccccc"
                        >
                          <use xlinkHref="#otherMoneyPassword_c96dfc31" />
                        </svg>
                      </div>
                      <div className="flex-list-con">
                        <p className="flex-list-header">
                          <span className="flex-list-text">
                            Transaction Password
                          </span>
                          <span className="flex-list-icon">
                            <svg className="am-icon am-icon-unsett_c1731e83 am-icon-xs flex-list-icon1 icon-complete flex-list-icon-unsett">
                              <use xlinkHref="#unsett_c1731e83" />
                            </svg>
                            <svg className="am-icon am-icon-edit_0f6eb9f1 am-icon-md edit-icon">
                              <use xlinkHref="#edit_0f6eb9f1" />
                            </svg>
                          </span>
                        </p>
                        <p className="flex-list-title flex-list-desc">
                          Set a fund password to improve the security of fund
                          operations
                        </p>
                      </div>
                      <div className="flex-grad-arrows">
                        <svg
                          className="am-icon am-icon-rightarrows_e029c01f am-icon-md"
                          color="#A6A6A6"
                        >
                          <use xlinkHref="#rightarrows_e029c01f" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="am-list-ripple" style={{ display: "none" }} />
                </div> */}
                <div
                  onClick={() => logoutUser()}
                  className="flex-list-item am-list-item am-list-item-middle"
                >
                  <div className="am-list-line">
                    <div className="am-list-content">
                      <div className="flex-grad-one">
                        <svg
                          className="am-icon am-icon-logout_aae7786e am-icon-lg flex-list-icon1 security-icon"
                          color="#cccccc"
                        >
                          <use xlinkHref="#logout_aae7786e" />
                        </svg>
                      </div>
                      <div className="flex-list-con">
                        <p className="flex-list-header">
                          <span className="flex-list-text">Logout</span>
                        </p>
                        <p className="flex-list-title flex-list-desc">
                          Logout safely
                        </p>
                      </div>
                      <div className="flex-grad-arrows" />
                    </div>
                  </div>
                  <div className="am-list-ripple" style={{ display: "none" }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityCenter;
